//-------------------------------------------------------------------------
// blocks selecting delay for the lowest-ranked combatant in the current CA
// when no higher-ranked combatant in that same CA is already on delay
//-------------------------------------------------------------------------
export default function isLastCurrentActionDelaySelection(parm) {
  if (parm.selected_action?.name !== 'delay') {
    return false
  }

  if (parm.view_round !== parm.arena_round) {
    return false
  }

  if (parm.arena_action <= 0 || parm.num !== parm.arena_action) {
    return false
  }

  const targetCombatant = parm.props?.row
  if (!targetCombatant) {
    return false
  }

  const caName = `ca_name${parm.arena_action}`
  const currentActionCombatants = (parm.combatants ?? []).filter(
    (combatant) =>
      combatant.status !== 'Inactive' &&
      combatant[caName] !== undefined &&
      combatant[caName] !== 'blank',
  )

  if (currentActionCombatants.length === 0) {
    return false
  }

  const hasLowerRankCombatant = currentActionCombatants.some(
    (combatant) => combatant.id !== targetCombatant.id && combatant.rank < targetCombatant.rank,
  )

  if (hasLowerRankCombatant) {
    return false
  }

  const hasHigherRankDelay = currentActionCombatants.some(
    (combatant) =>
      combatant.id !== targetCombatant.id &&
      combatant.rank > targetCombatant.rank &&
      combatant[caName] === 'delay',
  )

  return !hasHigherRankDelay
}
